import { render, staticRenderFns } from "./host-product-home.vue?vue&type=template&id=2c7efef3&scoped=true&"
import script from "./host-product-home.vue?vue&type=script&lang=js&"
export * from "./host-product-home.vue?vue&type=script&lang=js&"
import style0 from "./host-product-home.vue?vue&type=style&index=0&id=2c7efef3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7efef3",
  null
  
)

export default component.exports